// Shared rendering helpers for the live-vehicle overlay — used by BOTH the
// Google and Leaflet map engines so markers/cards look identical everywhere.

// UK number plates in our asset records occasionally differ from Quartix by a
// single leading character (e.g. app "DG74 NHO" vs Quartix "BG74 NHO"). The
// trailing 5 alphanumerics (age digits + unique letters) are reliable, so we
// scope per-map vehicle filtering on that suffix.
export function regKey(r) {
  const k = (r || "").replace(/[^a-z0-9]/gi, "").toUpperCase();
  return k.length > 5 ? k.slice(-5) : k;
}

export function buildRegSet(regs) {
  if (!regs || !regs.length) return null;
  return new Set(regs.map(regKey).filter(Boolean));
}

export function matchesRegSet(reg, regSet) {
  if (!regSet) return true;
  return regSet.has(regKey(reg));
}

export function fmtEventTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch (e) {
    return iso;
  }
}

// White van marker with a coloured status dot (green = moving, slate = stationary).
// The slate outline keeps it visible against light/green map backgrounds.
export function vanIconSvg(heading, moving) {
  const dot = moving ? "#059669" : "#64748b";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 40 40">
    <g stroke="#334155" stroke-width="1.4" stroke-linejoin="round">
      <path d="M4 24 V15.5 a2 2 0 0 1 2-2 H23 l7 5.5 V24 a1 1 0 0 1-1 1 H5 a1 1 0 0 1-1-1 Z" fill="#ffffff"/>
      <path d="M23 13.5 l7 5.5 h-7 z" fill="#cbd5e1"/>
      <circle cx="12" cy="25.5" r="3.2" fill="#ffffff"/>
      <circle cx="26" cy="25.5" r="3.2" fill="#ffffff"/>
      <circle cx="12" cy="25.5" r="1.3" fill="#334155" stroke="none"/>
      <circle cx="26" cy="25.5" r="1.3" fill="#334155" stroke="none"/>
    </g>
    <circle cx="33.5" cy="9" r="5" fill="${dot}" stroke="#ffffff" stroke-width="1.6"/>
  </svg>`;
}

export const VAN_SIZE = 40;

// Both engines use the white-van SVG (not the Quartix stock image).
export function vanMarkerImageUrl(v) {
  return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(vanIconSvg(v.heading, v.moving));
}

export function vanDivHtml(v) {
  return vanIconSvg(v.heading, v.moving);
}

export function vehiclePopupHtml(v) {
  const t = fmtEventTime(v.lastEventTime);
  return [
    `<div style="min-width:210px" data-testid="vehicle-card-${v.vehicleId}">`,
    `<div style="font-weight:700;font-size:13px">${v.registration || "(no reg)"}</div>`,
    v.description ? `<div style="color:#64748b;font-size:11px;margin-bottom:5px">${v.description}</div>` : "",
    `<div style="font-size:12px;line-height:1.6">`,
    `Status: <b style="color:${v.moving ? "#16a34a" : "#475569"}">${v.moving ? `Moving · ${v.speedKph} km/h` : "Stationary"}</b><br/>`,
    v.lastEventDescription ? `Last event: ${v.lastEventDescription}<br/>` : "",
    t ? `Updated: ${t}<br/>` : "",
    v.locationText ? `<span style="color:#64748b">${v.locationText}</span>` : "",
    `</div>`,
    `</div>`,
  ].join("");
}
